// extracted by mini-css-extract-plugin
export default {"flashing-dots-container":"LoadingDots_flashing-dots-container__gDT4m","dot-flashing":"LoadingDots_dot-flashing__qIN-X"};